import { useTheme } from "../hooks/useTheme";

const DarkModeToggle = () => {
  const { isDarkMode, toggleDarkMode } = useTheme();

  return (
    <label className="toggle-wrapper cursor-pointer" htmlFor="theme-toggle">
      <div className={`toggle ${isDarkMode ? "enabled" : "disabled"}`}>
        <span className="sr-only">
          {isDarkMode ? "Enable Light Mode" : "Enable Dark Mode"}
        </span>
        <div className="icons">
          {/* Sun icon */}
          <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
            <path d="M12 2.25a.75.75 0 01.75.75v2.25a.75.75 0 01-1.5 0V3a.75.75 0 01.75-.75zM7.5 12a4.5 4.5 0 119 0 4.5 4.5 0 01-9 0zM18.894 6.166a.75.75 0 00-1.06-1.06l-1.591 1.59a.75.75 0 101.06 1.061l1.591-1.59zM21.75 12a.75.75 0 01-.75.75h-2.25a.75.75 0 010-1.5H21a.75.75 0 01.75.75zM17.834 18.894a.75.75 0 001.06-1.06l-1.59-1.591a.75.75 0 10-1.061 1.06l1.59 1.591zM12 18a.75.75 0 01.75.75V21a.75.75 0 01-1.5 0v-2.25A.75.75 0 0112 18zM7.758 17.303a.75.75 0 00-1.061-1.06L5.106 17.834a.75.75 0 001.06 1.06l1.592-1.591zM6 12a.75.75 0 01-.75.75H3a.75.75 0 010-1.5h2.25A.75.75 0 016 12zM6.697 7.757a.75.75 0 001.06-1.06l-1.59-1.592a.75.75 0 00-1.061 1.061l1.59 1.591z" />
          </svg>

          {/* Moon icon */}
          <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
            <path
              fillRule="evenodd"
              d="M9.528 1.718a.75.75 0 01.162.819A8.97 8.97 0 009 6a9 9 0 009 9 8.97 8.97 0 003.463-.69.75.75 0 01.981.98 10.503 10.503 0 01-9.694 6.46c-5.799 0-10.5-4.701-10.5-10.5 0-4.368 2.667-8.112 6.46-9.694a.75.75 0 01.818.162z"
              clipRule="evenodd"
            />
          </svg>
        </div>
        <input
          id="theme-toggle"
          name="theme-toggle"
          type="checkbox"
          checked={isDarkMode}
          onChange={toggleDarkMode}
          className="sr-only"
        />
      </div>

      <style jsx>{`
        .toggle-wrapper {
          width: 80px;
          display: block;
        }

        .toggle {
          height: 40px;
          width: 80px;
          background: ${isDarkMode ? "#f5f5f5" : "#333333"};
          border-radius: 25px;
          padding: 6px;
          position: relative;
          cursor: pointer;
          transition: background 0.3s ease;
        }

        .toggle::before {
          content: "";
          display: block;
          height: 28px;
          width: 28px;
          border-radius: 50%;
          background: ${isDarkMode ? "#333333" : "#f5f5f5"};
          position: absolute;
          z-index: 2;
          transform: translateX(${isDarkMode ? "40px" : "0"});
          transition:
            transform 0.3s ease,
            background 0.3s ease;
          top: 6px;
          left: 6px;
        }

        .icons {
          display: flex;
          justify-content: space-between;
          align-items: center;
          height: 100%;
          margin: 0 8px;
          position: relative;
          z-index: 1;
        }

        .icons svg {
          fill: ${isDarkMode ? "#333333" : "#f5f5f5"};
          height: 18px;
          width: 18px;
          transition: fill 0.3s ease;
        }

        .sr-only {
          position: absolute;
          width: 1px;
          height: 1px;
          padding: 0;
          margin: -1px;
          overflow: hidden;
          clip: rect(0, 0, 0, 0);
          white-space: nowrap;
          border: 0;
        }
      `}</style>
    </label>
  );
};

export default DarkModeToggle;
